export const languageList = [
  { id: "es", lang: "Spanish", speech: "es-MX" },
  { id: "fr", lang: "French", speech: "fr-CA" },
  { id: "de", lang: "German", speech: "de-DE" },
  { id: "it", lang: "Italian", speech: "it-IT" },
  { id: "ja", lang: "Japanese", speech: "ja-JP" },
  { id: "pt", lang: "Portuguese", speech: "pt-BR" },
  { id: "ru", lang: "Russian", speech: "ru-RU" },
];
